/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetEvChargingSessionStatsPathParameters } from 'api/actions/get-ev-charging-session-stats/get-ev-charging-session-stats-path-parameters';
import { GetEvChargingSessionStatsResponse } from 'api/actions/get-ev-charging-session-stats/get-ev-charging-session-stats-response';

type GetEvChargingSessionStatsQueryParameters = Record<string, any>;

/**
 * The path of the GetEvChargingSessionStats action.
 */
export const getEvChargingSessionStatsActionPath = new SweetPath<keyof GetEvChargingSessionStatsPathParameters>(
  '/ev-charging-stations/{evChargingStationId}/session-stats',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetEvChargingSessionStats actions.
 */
export default function createGetEvChargingSessionStatsAction(axios: AxiosInstance) {
  return function getEvChargingSessionStatsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetEvChargingSessionStatsPathParameters;
    query?: GetEvChargingSessionStatsQueryParameters;
  }) {
    const path = getEvChargingSessionStatsActionPath.insert(parameters);

    return axios.get<GetEvChargingSessionStatsResponse, GetEvChargingSessionStatsResponse>(path, {
      params: query,
      headers,
    });
  };
}
